import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IPageHeaderMeta } from './page-header-meta.interface';

@Component({
  selector: 'page-header',
  template: require('./page-header.component.html'),
  styles: [require('./page-header.component.scss')],
})
export class PageHeaderComponent implements OnInit {
  @Input() pageHeaderMeta: IPageHeaderMeta;
  @Input() filterFormControl: FormControl;
  @Input() showSearchBox: boolean = true;

  public placeholder: string;

  ngOnInit() {
    if (this.pageHeaderMeta.textboxPlaceholder) {
      this.placeholder = this.pageHeaderMeta.textboxPlaceholder;
    } else {
      this.placeholder = 'Search by name or ID';
    }
  }

  public onClear() {
    this.filterFormControl.setValue('');
  }
}
